define.alias("shared/modifiers/circular-upload-animation", "media/modifiers/circular-upload-animation");